export const styles = {
  exhibitButtons: {
    container: {
      display: 'flex',
    },
    icon: {
      fontSize: 12,
      color: '#4D4D4D',
      height: 14,
      width: 14,
      verticalAlign: 'text-top',
      paddingTop: 2,
    },
    flatIcon: {
      fontSize: 12,
      fill: '#4d4d4d',
      height: 14,
      width: 14,
      verticalAlign: 'middle',
      marginLeft: 0,
    },
  },
  mobile: {
    isFeatured: {
      container: {
        width: '100%',
        minHeight: 145,
        overflow: 'hidden',
        border: '1px solid #EFEFEF',
        marginBottom: 10,
        display: 'flex',
        borderRadius: 5,
        paddingBottom: 75,
      },
      logo: {
        maxWidth: 150,
        maxHeight: 60,
        marginTop: 5,
        marginBottom: 10,
        position: 'absolute',
        bottom: 0,
      },
      productImage: {
        maxWidth: 130,
        maxHeight: 390,
        margin: 0,
        top: 10,
        right: 0,
        position: 'absolute',
      },
      productImageColumn: { flex: '0 0 130px', position: 'relative' },
    },
    noFeatured: {
      container: {
        width: '100%',
        minHeight: 100,
        overflow: 'hidden',
        border: '1px solid #EFEFEF',
        marginBottom: 10,
        display: 'flex',
        borderRadius: 5,
        paddingBottom: 45,
      },
      logo: {
        maxWidth: 75,
        maxHeight: 30,
        marginTop: 5,
        marginBottom: 10,
        position: 'absolute',
        bottom: 0,
      },
      productImage: {
        maxWidth: 110,
        maxHeight: 270,
        margin: 0,
        top: 10,
        right: 0,
        position: 'absolute',
      },
      productImageColumn: { flex: '0 0 110px', position: 'relative' },
    },
  },
  standard: {
    isFeatured: {
      container: {
        boxSizing: 'border-box',
        width: 'calc(50% - 12px)',
        minWidth: 300,
        minHeight: 145,
        overflow: 'hidden',
        border: '1px solid #EFEFEF',
        display: 'flex',
        marginBottom: '20px',
        right: 0,
        borderRadius: 5,
        paddingBottom: 75,
      },
      logo: {
        maxWidth: 150,
        maxHeight: 60,
        marginTop: 5,
        marginBottom: 10,
        position: 'absolute',
        bottom: 0,
      },
      productImage: {
        maxWidth: 130,
        maxHeight: 390,
        margin: 0,
        top: 10,
        right: 0,
        position: 'absolute',
      },
      productImageColumn: { flex: '0 0 130px', position: 'relative' },
    },
    noFeatured: {
      container: {
        boxSizing: 'border-box',
        width: 'calc(50% - 12px)',
        minWidth: 300,
        minHeight: 100,
        overflow: 'hidden',
        border: '1px solid #EFEFEF',
        display: 'flex',
        marginBottom: '20px',
        borderRadius: 5,
        paddingBottom: 45,
      },
      logo: {
        maxWidth: 75,
        maxHeight: 30,
        marginTop: 5,
        marginBottom: 10,
        position: 'absolute',
        bottom: 0,
      },
      productImage: {
        maxWidth: 110,
        maxHeight: 270,
        margin: 0,
        top: 10,
        right: 0,
        position: 'absolute',
      },
      productImageColumn: { flex: '0 0 110px', position: 'relative' },
    },
  },
}
export default styles
